import { FunctionComponent, ReactElement } from 'react';
import Parser from 'html-react-parser';
import l from '../../../../../../lang';
import CardStep from '..';
import { StatusKYCStepOne } from '../../enums/StatusKYCStepOne';
import { CardStyle } from '../../enums/CardStyle';
import ButtonCustom from '../../../../../common/__deprecated__/button-custom';
import ContentStep from '../../content-steps';
import { segmentKycStep1CompleteB } from '../../../../../../utils/analytics';

interface CardProps {
  cardStyle: CardStyle;
  tag: string;
  headline: string;
  subheadline: string | JSX.Element | JSX.Element[];
  content: string | JSX.Element | JSX.Element[];
  bottomElement: ReactElement;
  disabled: boolean;
}

const getCardPropsFromStatusKYCStepOne = (
  statusKycStepOne: StatusKYCStepOne,
  limitStepOne: number,
  onClickOneHandler: () => void
): CardProps => {
  let cardStyle = CardStyle.MAIN;
  let tag = '';
  let headline = '';
  let subheadline: string | JSX.Element | JSX.Element[];
  let content: string | JSX.Element | JSX.Element[];
  let bottomElement = <></>;
  let disabled = true;

  switch (statusKycStepOne) {
    case StatusKYCStepOne.REJECTED_BY_WEBSITE:
      cardStyle = CardStyle.WARNING;
      tag = l('companyInformation.steps.tag.reviewInformation.website');
      headline = l('companyInformation.step1.headline.reviewInformation.website');
      subheadline = l('companyInformation.step1.subheadline.reviewInformation.website');
      content = Parser(l('companyInformation.step1.content.completed', limitStepOne));
      bottomElement = <div className="info_steps__pending-line" />;
      break;
    case StatusKYCStepOne.REJECTED_BY_INDUSTRY:
      cardStyle = CardStyle.ERROR;
      tag = l('companyInformation.steps.tag.reviewInformation.industry');
      headline = l('companyInformation.step1.headline.reviewInformation.industry');
      subheadline = l('companyInformation.step1.subheadline.reviewInformation.industry');
      content = '';
      bottomElement = <div className="info_steps__error-line" />;
      break;
    case StatusKYCStepOne.COMPLETED:
      cardStyle = CardStyle.SUCCESS;
      tag = l('companyInformation.steps.tag.completed');
      headline = l('companyInformation.step1.headline.completed');
      subheadline = Parser(l('companyInformation.step1.subheadline.completed'));
      content = Parser(l('companyInformation.step1.content.completed', limitStepOne));
      bottomElement = <div className="info_steps__completed-line" />;
      break;
    case StatusKYCStepOne.ENABLED:
      cardStyle = CardStyle.MAIN;
      tag = l('companyInformation.steps.tag.complete');
      headline = l('companyInformation.step1.headline.complete');
      subheadline = l('companyInformation.step1.subheadline.complete');
      content = l('companyInformation.step1.content.complete');
      bottomElement = (
        <ButtonCustom
          size="small-full"
          text={l('companyInformation.step1.button.complete')}
          onClick={onClickOneHandler}
          component={undefined}
          innerComponent={undefined}
          fullWidth={undefined}
        />
      );
      disabled = false;
      break;
  }

  return {
    tag,
    headline,
    cardStyle,
    subheadline,
    content,
    bottomElement,
    disabled,
  };
};

interface CardStepProps {
  statusKycStepOne: StatusKYCStepOne;
  onClick: (step: number) => void;
  limitStepOne: number;
}

export const CardStepOne: FunctionComponent<CardStepProps> = ({ statusKycStepOne, onClick, limitStepOne }) => {
  const onClickOne = (segmentOption: number) => {
    segmentKycStep1CompleteB(segmentOption);
    onClick(1);
  };

  const stepOneCardProps = getCardPropsFromStatusKYCStepOne(statusKycStepOne, limitStepOne, () => onClickOne(2));

  return (
    <CardStep
      cardStyle={stepOneCardProps.cardStyle}
      title={l('companyInformation.step1')}
      onClick={() => onClickOne(1)}
      tag={stepOneCardProps.tag}
      disabled={stepOneCardProps.disabled}
    >
      <ContentStep
        headline={stepOneCardProps.headline}
        subheadline={stepOneCardProps.subheadline}
        content={stepOneCardProps.content}
        bottomElement={stepOneCardProps.bottomElement}
      />
    </CardStep>
  );
};
